module.exports = __webpack_public_path__ + "img/amari_amarifdn.d0df246.png";